module.exports = __webpack_public_path__ + "static/media/thank-you.dddd0229.png";